import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import {
  Container,
  AttachmentLabel,
  Attachment,
  AttachmentButton,
  AttachmentFilename,
  AttachmentRemoveButon,
} from "./styles/fileinput-styles";

class FileInput extends Component {
  render() {
    const {
      innerRef,
      fileSelected,
      attachmentChange,
      removeAttachment,
      disabled,
    } = this.props;

    return (
      <Container>
        <AttachmentLabel
          htmlFor="thefile"
          id="attachment-label"
          className={fileSelected ? "file-selected" : null}
        >
          {!disabled && (
            <Attachment
              type="file"
              id="thefile"
              onChange={attachmentChange}
              style={{ display: "none" }}
              ref={innerRef}
            />
          )}{" "}
          <AttachmentButton id="chooseFile" />
          <AttachmentFilename id="fileName">
            {fileSelected
              ? `${innerRef.current.files[0].name.replace(
                  "C:\\fakepath\\",
                  ""
                )}`
              : "Attach a file"}
          </AttachmentFilename>
          {!fileSelected && <FontAwesomeIcon icon={faPlusCircle} />}
        </AttachmentLabel>
        <AttachmentRemoveButon
          id="remove-attachment"
          className={fileSelected ? "show" : null}
          onClick={removeAttachment}
        >
          remove this file
        </AttachmentRemoveButon>
      </Container>
    );
  }
}

FileInput.propTypes = {
  innerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  fileSelected: PropTypes.bool.isRequired,
  attachmentChange: PropTypes.func.isRequired,
  removeAttachment: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FileInput.defaultProps = {
  disabled: PropTypes.isNull,
  innerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isNull,
};

// eslint-disable-next-line react/no-multi-comp
export default React.forwardRef((props, ref) => (
  <FileInput innerRef={ref} {...props} />
));
